import { useRef, useLayoutEffect } from 'react';
import { gsap } from 'gsap';

const Preloader = ({ onComplete }) => {
    const containerRef = useRef(null);
    const counterRef = useRef(null);
    const textRef = useRef(null);

    useLayoutEffect(() => {
        const ctx = gsap.context(() => {
            const tl = gsap.timeline({
                onComplete: () => {
                    if (onComplete) onComplete();
                }
            });

            // Animate counter from 0 to 100
            tl.to(counterRef.current, {
                innerHTML: 100,
                duration: 2,
                snap: { innerHTML: 1 },
                ease: "power2.inOut",
                onUpdate: function () {
                    counterRef.current.innerHTML = Math.round(this.targets()[0].innerHTML) + "%";
                }
            });

            // Fade out counter and text
            tl.to([counterRef.current, textRef.current], {
                opacity: 0,
                duration: 0.5,
                ease: "power2.in"
            }, "+=0.2");

            // Slide up the curtain
            tl.to(containerRef.current, {
                yPercent: -100,
                duration: 1,
                ease: "power4.inOut"
            });

        }, containerRef);

        return () => ctx.revert();
    }, [onComplete]);

    return (
        <div
            ref={containerRef}
            className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#0F0F0F] text-white"
        >
            <div className="overflow-hidden mb-4">
                <img
                    ref={textRef}
                    src="/SQRX_White_Logo.png"
                    alt="Squarex Studios"
                    className="h-16 md:h-24 object-contain"
                    style={{ opacity: 1 }}
                />
            </div>
            <div ref={counterRef} className="text-xl md:text-2xl font-['JetBrains_Mono'] text-[#af0000]">
                0%
            </div>
        </div>
    );
};

export default Preloader;
